define('pages/reports/TimelyFiling/PaginationNavComponent',[
	'core/can',
	'template!pages/reports/TimelyFiling/PaginationNavView.stache'
], function(can, template) {
	
	return can.Component.extend({
		
		tag: 'pagination-nav',
		
		template: can.view(template),
		
		scope: {
			
			start: can.compute(function() {
				return this.attr('pagination.firstPage'); //Math.max(this.attr('pageNumber')-2, 1);
			}),
			
			end: can.compute(function() {
				
				if (this.attr('pagination.lastPage') < 5) {
					return this.attr('pagination.lastPage');
				} else {
					return Math.min(this.attr('start')+4, this.attr('pagination.lastPage'));
				}

			}),
			
			bookmarks: can.compute(function() {
				var a = [];
				for (var i=this.attr('start'); i<=this.attr('end'); i++) a.push(i);
				return a;
			}),
			
			hasMultiple: can.compute(function() {
				return this.attr('bookmarks').length > 1;
			})
		}, 
		
		events: {
			
			'inserted': 'setActivePage',
			'{scope} hasMultiple': 'setActivePage',
			'{scope.pagination} change': 'setActivePage',
			
			setActivePage: function() {
				var pageNumber = this.scope.attr('pagination.pageNumber'),
					$li = this.element.find('.pagination li');				
				$li.filter('.active').removeClass('active');
				$li.filter('.page').each(function(i, el) {
					el = $(el);
					if (el.data('page') === pageNumber) {
						el.addClass('active');
					}
				});
			}
		}
	});
	
});
